export default {
  control: 'control',
  off: 'off',
  on: 'on',
  optedOut: 'optedOut',
  protectControl: 'protect_control',
};
